import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';

const useTranslationPagoNubeOnboarding = (keyPrefix?: string) => {
  const { t } = useTranslation(Domain.PAGO_NUBE_ONBOARDING, { keyPrefix });
  return t;
};

export default useTranslationPagoNubeOnboarding;
